import React, { useState } from "react";
import { X, Send } from "react-feather";
import agentActivityService from "../../../services/agentActivityService";
import { success, error as notifyError } from "../../../utils/notification";

interface ISendEmailModalProps {
    isOpen: boolean;
    onClose: () => void;
    activityId: string;
    supplierEmail: string;
    supplierName: string;
    onSuccess: (updatedActivity: any) => void;
}

const SendEmailModal: React.FC<ISendEmailModalProps> = ({
    isOpen,
    onClose,
    activityId,
    supplierEmail,
    supplierName,
    onSuccess
}) => {
    const [subject, setSubject] = useState(`Inquiry about Ingredient for Journey Foods`);
    const [body, setBody] = useState(`<p>Hello ${supplierName},</p><p>We are interested in your products and would like to discuss a potential partnership.</p><p>Best regards,<br/>Journey Foods Team</p>`);
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await agentActivityService.sendEmail({
                activity_id: activityId,
                supplier_email: supplierEmail,
                supplier_name: supplierName,
                subject,
                body_html: body
            });
            success("Email sent successfully!");
            onSuccess(response.data);
            onClose();
        } catch (err) {
            const error = err as any;
            console.error("Failed to send email:", error);
            notifyError(error.response?.data?.message || "Failed to send email. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content email-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Send Outreach Email</h2>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>To</label>
                            <input type="text" value={`${supplierName} <${supplierEmail}>`} disabled className="form-control" />
                        </div>
                        <div className="form-group">
                            <label>Subject</label>
                            <input
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Message (HTML supported)</label>
                            <textarea
                                value={body}
                                onChange={(e) => setBody(e.target.value)}
                                required
                                className="form-control"
                                rows={8}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? "Sending..." : "Send Email"}
                            {!loading && <Send size={16} style={{ marginLeft: 8 }} />}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SendEmailModal;
